export enum IdentityVerificationDocumentTypes {
  ID_CARD = "id_card",
  PASSPORT = "passport",
  RESIDENCE_PERMIT = "residence_permit",
  DRIVER_LICENSE = "driver_license",
}
